var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('top-bar'),_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"main-body-content"},[_c('PageBuild')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }